// extracted by mini-css-extract-plugin
module.exports = {"popover":"Popovers_popover__35kSE","sliderPopover":"SliderPopover_sliderPopover__2Merj Popovers_popover__35kSE","sliderTitle":"SliderPopover_sliderTitle__2b-fy"};